import React, { Fragment, Component } from "react";

export default class SkipModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingModal: false
    };
  }
  handleCloseClick = e => {
    if (
      e.target.classList.contains("info-modal") ||
      e.target.classList.contains("close")
    ) {
      this.setState({ isShowingModal: false });
    }
  };
  handleOpenClick = _ => this.setState({ isShowingModal: true });
  render() {
    return (
      <Fragment>
        {!this.state.isShowingModal && (
          <button onClick={this.handleOpenClick} className="info">
            {" "}
            ?
          </button>
        )}
        {this.state.isShowingModal && (
          <div onClick={this.handleCloseClick} className="info-modal">
            <div className="modal-content">
              <div onClick={this.handleCloseClick} className="close">
                x
              </div>
              <p>
                The sections of this site are unlocked by solving puzzles. They're
                fun, little time wasters, but you can use the button below to
                skip them and unlock the whole site.
              </p>
              <button onClick={this.props.onSkipPuzzles}>Skip Puzzles</button>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SkipModal.js